import * as z from "zod/v4";

export const bulkAssignWorkOrderTotes = {
  name: "bulkAssignWorkOrderTotes" as const,
  input: z.object({ workOrderIds: z.array(z.string()), barcode: z.string() }),
  output: z.object({
    toteStorageLocationId: z.string(),
    toteStorageLocationName: z.string(),
    assignedCount: z.number(),
  }),
};
